export default __webpack_public_path__ + "static/media/click.7618076a.mp3";